import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams } from 'react-router-dom';
import { getPracticeAdminHomePath, isPracticeAdmin } from '../../../utils/roleUtils';

/**
 * Ensures Practice Admins can only open their assigned practice routes.
 */
const PracticeScopeRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const { practiceId } = useParams();

  if (isPracticeAdmin(user) && user?.practice_id && practiceId) {
    if (String(practiceId) !== String(user.practice_id)) {
      return <Navigate to={getPracticeAdminHomePath(user)} replace />;
    }
  }

  return children;
};

export default PracticeScopeRoute;
